module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/instagram-59214d6032f6290510bee104744f82b7.svg";